import React, { useEffect } from 'react';

// Indicateur visuel "+" rouge en bas à droite d'un calque texte quand le
// contenu déborde du conteneur (style Adobe Illustrator). Polling DOM léger
// (toutes les 500 ms) car le contenu peut changer hors React (Tiptap, etc.).
export default function TextOverflowIndicator({ elId }) {
    const [isOverflowing, setIsOverflowing] = React.useState(false);

    useEffect(() => {
        const check = () => {
            const container = document.querySelector(`[data-text-container="${elId}"]`);
            if (!container) return;
            const inner = container.querySelector('[data-text-inner]');
            if (!inner) return;
            // Compare la hauteur scaled du contenu interne avec celle du container
            const containerH = container.offsetHeight;
            const innerH = inner.scrollHeight / 10; // TEXT_SCALE = 10
            setIsOverflowing(innerH > containerH + 0.5);
        };
        check();
        const timer = setInterval(check, 500);
        return () => clearInterval(timer);
    }, [elId]);

    if (!isOverflowing) return null;
    return (
        <div data-no-export="true" style={{
            position: 'absolute', bottom: 0, right: 0, zIndex: 50,
            width: '2px', height: '2px',
            backgroundColor: '#ef4444',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: '2px', color: 'white', fontWeight: 'bold', lineHeight: 1,
            pointerEvents: 'none', opacity: 0.9,
        }}>+</div>
    );
}
